import PropTypes from 'prop-types';

export const tax = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  addToPrice: PropTypes.bool.isRequired,
  externalOrdersOnly: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  assignments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    percentage: PropTypes.number,
  })),
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    enabled: PropTypes.bool.isRequired,
  })),
  services: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    enabled: PropTypes.bool.isRequired,
  })),
});

export const productItemShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  category: PropTypes.string,
});

export const serviceItemShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  category: PropTypes.string,
});

export const columnDescriptor = PropTypes.shape({
  name: PropTypes.string,
  header: PropTypes.string,
});

export const tableColumns = PropTypes.arrayOf(columnDescriptor);
export const taxes = PropTypes.arrayOf(tax);
export const handler = PropTypes.func;
export const edit = PropTypes.bool;
export const pristine = PropTypes.bool;
export const submitting = PropTypes.bool;
export const valid = PropTypes.bool;
export const invalid = PropTypes.bool;
export const url = PropTypes.string;
export const flag = PropTypes.bool;
export const renderFunction = PropTypes.func;
